var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FitDialog',{directives:[{name:"show",rawName:"v-show",value:(_vm.dialog.show),expression:"dialog.show"}],attrs:{"title":_vm.dialog.title,"content":_vm.dialog.content,"btns":_vm.dialog.btns,"align":_vm.dialog.align,"htmlContent":_vm.dialog.htmlContent},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }